import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { addIcons } from 'ionicons';

import {
  Field,
  Input as IInput,
  InputType,
} from 'src/app/interfaces/components/elements/Input';
import { ButtonStyles } from 'src/app/interfaces/components/elements/Button';
import { DatetimePickerComponent } from '../datetime-picker/datetime-picker.component';
import { calendarOutline, closeOutline } from 'ionicons/icons';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    NgxMaskDirective,
    DatetimePickerComponent,
  ],
  providers: [provideNgxMask()],
})
export class InputComponent implements OnInit {
  @Input() parentForm!: FormGroup;
  @Input() data: IInput = {
    field: Field.Text,
    type: InputType.Text,
    placeholder: '',
    formControlName: '',
    mask: null,
    value: '',
    inline: false,
  };
  @Input() buttonStyles?: any;

  @Output() valueChange = new EventEmitter<string>();

  constructor() {
    addIcons({ calendarOutline, closeOutline });
  }

  ngOnInit() {}

  public onInputChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.valueChange.emit(target.value);
  }

  public onDateTimeChange(value: string): void {
    if (this.data.formControlName && this.parentForm) {
      this.parentForm.get(this.data.formControlName)?.setValue(value);
    }
    this.valueChange.emit(value);
  }
}
